import React, { useState } from 'react';
import './App.css';
import FoodList from './components/FoodList/FoodList';
import CartModal from './components/CartModal/CartModal';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Nav from './components/NavBar/NavBar';
import foodItemsData from './components/Data/Data';
import { ToastContainer, toast } from 'react-toastify';

function App({ clearCart }) {
  const [currentCategory, setCurrentCategory] = useState('breakfast');
  const [cart, setCart] = useState({});
  const [showModal, setShowModal] = useState(false);

  const updateCart = (itemName, quantity) => {
    setCart(prev => {
      const updated = { ...prev };
      if (quantity <= 0) {
        delete updated[itemName];
      } else {
        updated[itemName] = quantity;
      }
      return updated;
    });
  };

  const getItemDetailsByName = (itemName) => {
    for (const category in foodItemsData) {
      const item = foodItemsData[category].find(item => item.name === itemName);
      if (item) return item;
    }
    return null;
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header cartCount={Object.values(cart).reduce((a, b) => a + b, 0)} onCartClick={() => setShowModal(true)} />
      <Nav current={currentCategory} setCurrent={setCurrentCategory} />
      <main className="container mx-auto p-6 flex-grow">
        <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
          {currentCategory.charAt(0).toUpperCase() + currentCategory.slice(1)}
        </h2>
        <FoodList
          items={foodItemsData[currentCategory]}
          cart={cart}
          updateCart={updateCart}
        />
      </main>
      {showModal && (
        // <CartModal
        //   cart={cart}
        //   getItemDetailsByName={getItemDetailsByName}
        //   updateCart={updateCart}
        //   onClose={() => setShowModal(false)}
        // />
        <CartModal
          cart={cart}
          getItemDetailsByName={getItemDetailsByName}
          updateCart={updateCart}
          onClose={() => setShowModal(false)}
          clearCart={() => setCart({})}  // ✅ pass clearCart here!
        />
      )}
      <Footer />
      <ToastContainer position="top-center" autoClose={2000} />
    </div>
  );
}

export default App;